import React from 'react';
import { connect } from 'react-redux';
import { Grid } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import BackgroundStockVideosCard from './BackgroundStockVideosCard';
import EmptyGalleryLabel from '../../../common/EmptyGalleryLabel';
import BackgroundStockVideosLoadMoreCard from './BackgroundStockVideosLoadMoreCard';

const styles = theme => ({
    galleryProgress: {
        margin: theme.spacing(4, 0, 4, 0) 
    },
    videosContentWrapper: {
        padding: `${theme.spacing(2)} 0`
    }
});

const galleryCardWidth = 222;
const galleryCardHeight = 124;

const BackgroundStockVideosContainer = (props) => {
    const { classes, backgroundStockVideos, backgroundStockVideosAllCount } = props;

    return (
        <Grid className={classes.videosContentWrapper}>
            <Grid
                container
                direction='row'
                justifyContent='center'
                alignItems='flex-start'
            >
                {
                    backgroundStockVideos && backgroundStockVideos.length
                        ?
                        <>
                            {backgroundStockVideos.map((video, index) =>
                                <BackgroundStockVideosCard
                                    key={video.id}
                                    index={index}
                                    catalogVideo={video}
                                    galleryCardWidth={galleryCardWidth}
                                    galleryCardHeight={galleryCardHeight}
                                />
                            )}

                            {backgroundStockVideos.length < backgroundStockVideosAllCount &&
                                <BackgroundStockVideosLoadMoreCard
                                    galleryCardWidth={galleryCardWidth}
                                    galleryCardHeight={galleryCardHeight}
                                />
                            }
                        </>
                        :
                        <EmptyGalleryLabel />
                }
            </Grid>
        </Grid>
    );
};

const mapStateToProps = (state) => {
    const { 
        backgroundStockVideos,
        backgroundStockVideosAllCount,  
    } = state.mediaPicker;

    return { 
        backgroundStockVideos,
        backgroundStockVideosAllCount
    };
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(BackgroundStockVideosContainer, styles));